module.exports = __webpack_public_path__ + "images/message-delivery-icon1252402942c9835551cdade9ea914549.svg";